import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import {
  QUESTION_RATING,
  QUESTION_SLIDER,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERICAL_OPEN_ENDED,
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_VAN_WESTENDORP,
  QUESTION_MATRIX_MAXDIFF,
  QUESTION_DRILLDOWN,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_OPEN_ENDED_NUMERIC,
  QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM,
  QUESTION_CONVERSATIONAL,
} from '../../constants';
import InputNumeric from './InputNumeric';
import RatingStars from './RatingStars';
import OpenEnded from './OpenEnded';
import DrilldownQuestion from './DrilldownQuestion';
import Ranking from './Ranking';
import Matrix from './Matrix';
import Slider from './Slider';
import MatrixMaxDiff from './MatrixMaxDiff';
import MatrixVanWestendorp from './MatrixVanWestendorp';
import MatrixBipolar from './Matrix/MatrixBipolar';
import MatrixOpenEnded from './Matrix/MatrixOpenEnded';
import Conversational from './Matrix/Conversational';

export default function QuestionBody({ question, answers, scorepoints }) {
  const { getText } = Pollfish.ui;

  const isRtlEnabled = $('html').attr('dir') === 'rtl';
  switch (question.style) {
    case QUESTION_RATING:
      return <RatingStars question={question} />;
    case QUESTION_SLIDER:
      return <Slider question={question} rtl={isRtlEnabled} />;
    case QUESTION_OPEN_ENDED:
      return <OpenEnded question={question} />;
    case QUESTION_NUMERICAL_OPEN_ENDED:
      return (
        <InputNumeric
          questionRefId={question.refId || question.id}
          min={question.min}
          max={question.max}
        />
      );
    case QUESTION_RANKING:
      return (
        <Ranking question={question} answers={answers} getText={getText} />
      );
    case QUESTION_MATRIX_SINGLE:
    case QUESTION_MATRIX_MULTIPLE:
      return (
        <Matrix
          question={question}
          answers={answers}
          scorepoints={scorepoints}
          getText={getText}
        />
      );
    case QUESTION_MATRIX_VAN_WESTENDORP:
      return <MatrixVanWestendorp question={question} />;
    case QUESTION_MATRIX_MAXDIFF: {
      const group = find(Pollfish.survey.groups, [
        'refId',
        question.groupRefId,
      ]);
      if (!group) {
        throw new Error('Could not find group from refId');
      }

      const currentChoiceSet = group.getCurrentChoiceSet();
      if (!currentChoiceSet) {
        throw new Error('Missing a current concept set for group');
      }

      return (
        <MatrixMaxDiff
          question={question}
          currentChoiceSet={currentChoiceSet}
        />
      );
    }
    case QUESTION_MATRIX_BIPOLAR:
      return <MatrixBipolar question={question} rtl={isRtlEnabled} />;
    case QUESTION_DRILLDOWN:
      return <DrilldownQuestion question={question} />;
    case QUESTION_MATRIX_OPEN_ENDED:
    case QUESTION_MATRIX_OPEN_ENDED_NUMERIC:
    case QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM:
      return <MatrixOpenEnded question={question} getText={getText} />;
    case QUESTION_CONVERSATIONAL:
      return <Conversational question={question} rtl={isRtlEnabled} />;
    default:
      return null;
  }
}

QuestionBody.propTypes = {
  question: PropTypes.object.isRequired,
  answers: PropTypes.array.isRequired,
  scorepoints: PropTypes.array.isRequired,
};
